// extracted by mini-css-extract-plugin
export default {"searchPopular":"SearchPopular_searchPopular__UwrN1"};